import $global from '@xt/client/store/global'
import type { ClasshourItem } from '@xt/client/entities/course-v2/types.d'
import type { Asset, Material, BaseTemplate, TopDirClasshourLayout, BottomDirClasshourLayout } from '../types.d'

export class TemplateThree implements BaseTemplate {
  /**
   * 当前课程进度 0 - 3
   */
  private taskSchedule: number
  /**
   * 头部课程(开学见面)是否已经发布
   */
  private withStartCourse: boolean
  /**
   * 尾部课程(小灶课)是否已经发布
   */
  private withEndCourse: boolean
  /**
   * 展示学习回顾
   */
  private showReview: boolean
  /**
   * 展示开课前请准备 与 学习回顾位置互斥
   */
  public showPrepare: boolean
  /**
   * 当前真实的课程进度索引，与taskSchedule相比 taskSchedule不会返回小灶课尾部课程的索引
   * 模版3  realCurrent: 0 - 4
   */
  public realCurrent: number

  constructor(options: {
    taskSchedule: number
    showReview: boolean
    showPrepare: boolean
    withStartCourse: boolean
    withEndCourse: boolean
    realCurrent: number
  }) {
    this.taskSchedule = options.taskSchedule
    this.showReview = options.showReview
    this.showPrepare = options.showPrepare
    this.withStartCourse = options.withStartCourse
    this.withEndCourse = options.withEndCourse
    this.realCurrent = options.realCurrent
  }

  private static assets: Record<string, Asset> = {
    'bg-style-v1': {
      url: `${$global.static}/images/course/pc/template/tpl-3/tpl-3-bg-style-v1.png`,
      width: 1082,
      height: 548
    },
    'material-sprite': {
      url: `${$global.static}/images/course/pc/template/tpl-3/tpl-3-sprites-v1.png`,
      width: 84,
      height: 923
    },
    'material-review': {
      url: `${$global.static}/images/course/pc/bg-review-v1.png`,
      width: 248,
      height: 218
    }
  }

  getTemplateSize() {
    return { width: 1082, height: 659, marginTop: 95, marginBottom: 0, marginLeft: 0 }
  }

  getBottomMaterialConfigList(): Array<Array<Material>> {
    const numberIndex = [
      [166, 314],
      [240, 124],
      [355, 486],
      [240, 904],
      [463, 769]
    ]

    return [
      [
        {
          type: 'normal',
          ...TemplateThree.assets['bg-style-v1'],
          visible: true,
          name: 'bg',
          top: 34,
          left: 0
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.withStartCourse,
          name: 'bg-tpl_3_number_star',
          top: numberIndex[0][0],
          left: numberIndex[0][1],
          x: -5,
          y: -5,
          self: {
            width: 27,
            height: 27
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.realCurrent !== 1,
          name: 'bg-tpl_3_number_1',
          top: numberIndex[1][0],
          left: numberIndex[1][1],
          x: -5,
          y: -151,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.realCurrent !== 2,
          name: 'bg-tpl_3_number_2',
          top: numberIndex[2][0],
          left: numberIndex[2][1],
          x: -5,
          y: -95,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.realCurrent !== 3,
          name: 'bg-tpl_3_number_3',
          top: numberIndex[3][0],
          left: numberIndex[3][1],
          x: -5,
          y: -207,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.withEndCourse,
          name: 'bg-tpl_3_number_star_end',
          top: numberIndex[4][0],
          left: numberIndex[4][1],
          x: -5,
          y: -5,
          self: {
            width: 27,
            height: 27
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.realCurrent !== 0 && this.realCurrent !== 4,
          name: 'bg-tpl_3_number_current',
          top: numberIndex[this.realCurrent][0],
          left: numberIndex[this.realCurrent][1],
          x: -5,
          y: -319,
          self: {
            width: 40,
            height: 47
          }
        }
      ]
    ]
  }

  getTopMaterialConfigList(): Array<Array<Material>> {
    return [
      [
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.taskSchedule === 1,
          name: 'bg-tpl_3_material_01',
          top: 112,
          left: 180,
          x: -5,
          y: -376,
          self: {
            width: 57,
            height: 69.5
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.taskSchedule === 2,
          name: 'bg-tpl_3_material_02',
          top: 227,
          left: 374,
          x: -5,
          y: -455.5,
          self: {
            width: 58,
            height: 70.5
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.taskSchedule === 0,
          name: 'bg-tpl_3_material_03',
          top: 85,
          left: 450,
          x: -5,
          y: -42,
          self: {
            width: 37,
            height: 43
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.taskSchedule === 3,
          name: 'bg-tpl_3_material_04',
          top: 138,
          left: 813,
          x: -5,
          y: -263,
          self: {
            width: 68.5,
            height: 46
          }
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateThree.assets['material-sprite'],
          visible: this.showPrepare,
          name: 'bg-tpl_3_prepare',
          top: -63,
          left: 1045,
          x: -5,
          y: -536,
          hover: {
            x: -5,
            y: -732
          },
          clickEventName: 'click-prepare',
          self: {
            width: 74,
            height: 186
          }
        },
        {
          type: 'sprite',
          ...TemplateThree.assets['material-review'],
          visible: this.showReview,
          name: 'bg-review',
          top: -83,
          left: 1015,
          x: -129,
          y: -5,
          hover: {
            x: -5,
            y: -5
          },
          clickEventName: 'click-review',
          self: {
            width: 114,
            height: 208
          }
        }
      ]
    ]
  }

  getClasshourLayoutInfo(_item: ClasshourItem, index: number): TopDirClasshourLayout | BottomDirClasshourLayout {
    switch (index) {
      case 0:
        return { directionStyle: 'bottom', bottom: 498, left: 248 } satisfies BottomDirClasshourLayout
      case 1:
        return { directionStyle: 'bottom', bottom: 429, left: 63 } satisfies BottomDirClasshourLayout
      case 2:
        return { directionStyle: 'bottom', bottom: 315, left: 425 } satisfies BottomDirClasshourLayout
      case 3:
        return { directionStyle: 'bottom', bottom: 428, left: 843 } satisfies BottomDirClasshourLayout
      case 4:
        return { directionStyle: 'top', top: 498, left: 703 } satisfies TopDirClasshourLayout
      default:
        throw new Error(`${index}`)
    }
  }
}
